module.exports = __webpack_public_path__ + "img/arts_design.dbda2402.png";